'use client';

import dynamic from 'next/dynamic';

import type { HeroParticlesVariant } from './HeroParticles.client';

// Canvas-only effect: nothing to SSR, and keeping it out of the server render keeps the hero's
// HTML (the LCP path) free of it — the heading is the LCP element in this mode. `ssr: false`
// is only allowed from a client module, hence this tiny wrapper.
const HeroParticlesNoSSR = dynamic(() => import('./HeroParticles.client').then((mod) => mod.HeroParticles), {
  ssr: false,
});

export const HeroParticlesLazy = ({ variant }: { variant?: HeroParticlesVariant }) => (
  <HeroParticlesNoSSR variant={variant} />
);
